import type { TaskOutputWithNewlyCreated } from "@orsane/schema/tasks";
import { createContext, use } from "react";

/**
 * Appends a new, still-unsaved task row. Pass `parentTask` to start the row nested
 * under that parent, so pressing Enter on a subtask keeps the next row a subtask.
 */
type AddTaskFn = (groupValue: any, parentTask?: TaskOutputWithNewlyCreated["parentTask"]) => void;

const AddTaskContext = createContext<AddTaskFn | null>(null);

export const AddTaskProvider = AddTaskContext.Provider;

export function useAddTask(): AddTaskFn | null {
    return use(AddTaskContext);
}
